import Observer from '../../common/scripts/observer';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class WhiteBox {
    constructor(options) {
        this.wrapper = options.wrapper;
    }

    init() {
        this._initElements();
    }

    _initElements() {
        if (!this.wrapper) {
            return;
        }

        // Имя таба с элементами WhiteBox
        this.tabName = this.wrapper.dataset.name;
        // Блок с изображением и поинтерами
        this.imageWrapper = this.wrapper.querySelector('.j-white-box__including-image') || null;
        // Блок со списком
        this.listWrapper = this.wrapper.querySelector('.j-white-box__including-block') || null;
        // Строки в блоке со списком
        this.listItems = [...this.listWrapper.querySelectorAll('.j-white-box__including-item')] || null;
        // Список поинтеров
        this.pointers = [...this.wrapper.querySelectorAll('.j-white-box__including-pointer')] || null;


        this._subscribe();

        this._bindEvents();
    }

    _subscribe() {
        observer.subscribe('tabChange', (elem) => {
            if (elem.dataset.tab === this.tabName) {
                this._setHeight();
            }
        });
    }

    /**
     * Устанавливаем высоту списка равную высоте изображения с поинтерами
     */
    _setHeight() {
        if (!this.imageWrapper || !this.listWrapper) {
            return;
        }

        this.height = this.imageWrapper.offsetHeight;
        this.listWrapper.style.height = Utils.isMobile() ? 'auto' : `${this.height}px`;
    }

    _bindEvents() {
        const resizeEvents = ['resize', 'orientationchange'];

        resizeEvents.forEach((resizeEvent) => {
            window.addEventListener(resizeEvent, () => {
                this._setHeight();
            });
        });

        if (Utils.isMobile()) {
            return;
        }

        this._bindListItems();

        this._bindPointers();
    }

    /**
     * ПОдписываемся на обработку событий поведения списка элементов
     */
    _bindListItems() {
        this.listItems.forEach((listItem) => {
            const itemNum = listItem.dataset.item || null;

            if (!itemNum) {
                return;
            }

            const activePointer = this.pointers.find((pointer) => {
                return Number(pointer.dataset.item) === Number(itemNum);
            });

            listItem.addEventListener('mouseenter', () => {
                activePointer?.classList.add('is-active');
            });

            listItem.addEventListener('mouseleave', () => {
                activePointer?.classList.remove('is-active');
            });
        });
    }

    /**
     * Подписываемся на обработку событий поведения поинтеров
     */
    _bindPointers() {
        this.pointers.forEach((pointer) => {
            const itemNum = pointer.dataset.item || null;

            const tooltip = pointer.querySelector('.j-white-box__including-tooltip');

            if (!itemNum) {
                return;
            }

            const activeListItem = this.listItems.find((listItem) => {
                return Number(listItem.dataset.item) === Number(itemNum);
            });

            pointer.addEventListener('mouseenter', () => {
                activeListItem?.classList.add('is-active');

                if (tooltip) {
                    this._setTooltipPosition(tooltip, pointer, true);
                }
            });

            pointer.addEventListener('mouseleave', () => {
                activeListItem?.classList.remove('is-active');

                if (tooltip) {
                    this._setTooltipPosition(tooltip, pointer, false);
                }
            });
        });
    }

    /**
     * Определяем положение тултипа
     * @param {HTMLElement} tooltip - элемент тултипа
     * @param {HTMLElement} pointer - элемент поинтера
     * @param {Boolean} state - состояние (показываем или скрываем)
     */
    _setTooltipPosition(tooltip, pointer, state) {
        if (!tooltip || !pointer) {
            return;
        }

        const pointerPosTop = pointer.offsetTop;
        const pointerPosLeft = pointer.offsetLeft;
        const tooltipWidth = tooltip.offsetWidth;
        const tooltipHeight = tooltip.offsetHeight;
        const method = state ? 'add' : 'remove';

        tooltip.classList[method]('is-active');

        if (state) {
            if (tooltipHeight + 8 > pointerPosTop) {
                tooltip.classList.add('white-box__including-tooltip_theme_bottom');
            }

            if (tooltipWidth / 2 > pointerPosLeft) {
                tooltip.classList.add('white-box__including-tooltip_theme_left');
            }

            if (((tooltipWidth / 2) + pointerPosLeft) > this.imageWrapper.offsetWidth) {
                tooltip.classList.add('white-box__including-tooltip_theme_right');
            }
        }
    }
}

export default WhiteBox;
